import type { MaybeRef } from "vue"
import type { IGuestbookMessageResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"
import { GuestbookMessage } from "@/models"

export interface IListGuestbookQuery {
  type?: "text" | "video"
}

export async function listGuestbook(eventVaultId?: number, albumId?: number, query: IListGuestbookQuery = {}): Promise<GuestbookMessage[]> {
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to list guestbook messages. Please ensure `eventVaultId` is provided.",
    )
  }

  const params = new URLSearchParams()

  if (albumId)
    params.append("album", encodeURIComponent(albumId))
  if (query.type)
    params.append("type", encodeURIComponent(query.type))

  const { data } = await axios.get(`/api/${eventVaultId}/messages?${params.toString()}`)

  return data.Data.map((message: IGuestbookMessageResponse) => GuestbookMessage.fromResponse(message))
}

export const LIST_GUESTBOOK_KEY = "listMessages"

export function useListGuestbook(eventVaultId: MaybeRef<number>, albumId: MaybeRef<number | undefined>, query: IListGuestbookQuery = {}) {
  return useQuery({
    queryKey: [LIST_GUESTBOOK_KEY, eventVaultId, albumId, query],
    queryFn: () => listGuestbook(toValue(eventVaultId), toValue(albumId), query),
    enabled: !!toValue(eventVaultId),
  })
}
